import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import RentTabs from "../components/RentComponents/RentTabs";
import RentSettings from '../components/RentComponents/RentSettings/RentSettings';
import Clients from './../components/RentComponents/ClientsTab/Clients';
import Operators from './../components/RentComponents/OperatorsTab/Operators';
import Pricing from '../components/RentComponents/PricingTab/Pricing';
import ActionCreator from './../store/actions/index';

const RentsView = props => {
    const [tab, setTab] = useState(0);

    useEffect(() => {
        props.getRentSettings();
        props.getRentOperators();
        props.getRentPricing();
    }, []);

    return (
        <div>
            <RentTabs value={tab} onTabChange={setTab} />
            {tab === 0 && <RentSettings />}
            {tab === 1 && <Clients />}
            {tab === 2 && <Operators/>}
            {tab === 3 && <Pricing />}
        </div>
    );
};

const mapStateToProps = state => ({
    settings: state.rentReducer.settings,
    clients: state.rentReducer.clients,
    operators: state.rentReducer.operators,
    pricing: state.rentReducer.pricing
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

RentsView.propTypes = {
    getRentSettings: PropTypes.func,
    getRentOperators: PropTypes.func,
    getRentPricing: PropTypes.func
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RentsView);